<template>
	<div class="w-full">
		<div class="animate-pulse">
			<div class="flex-1 space-y-6 py-1">
				<div class="h-2 bg-slate-300 rounded"></div>
				<div class="space-y-4">
					<div class="grid grid-cols-3 gap-4">
						<div class="h-2 bg-slate-300 rounded col-span-2"></div>
						<div class="h-2 bg-slate-300 rounded col-span-1"></div>
					</div>
					<div class="grid grid-cols-3 gap-4">
						<div class="h-2 bg-slate-300 rounded col-span-1"></div>
						<div class="h-2 bg-slate-300 rounded col-span-2"></div>
					</div>
					<div class="grid grid-cols-3 gap-4">
						<div class="h-2 bg-slate-300 rounded col-span-2"></div>
						<div class="h-2 bg-slate-300 rounded col-span-1"></div>
					</div>
					<div class="h-2 bg-slate-300 rounded"></div>
				</div>
			</div>
		</div>
	</div>
</template>
